import React from 'react';
export function HeroSection() {
  return <div className="bg-navy py-16 px-4" data-id="element-3107">
      <div className="max-w-4xl mx-auto text-center" data-id="element-3108">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight" data-id="element-3109">
          Manufacturing Industry News
        </h1>
      </div>
    </div>;
}